import React from "react";

import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  NumberField,
  BooleanField,
  EditButton,
  DeleteButton,
  ImageField,
  Filter, SelectInput, AutocompleteInput,
  ReferenceInput,
  SearchInput, TextInput
} from "react-admin";
import { DisplayDate } from "../../common/DisplayDate";
import Button from '@material-ui/core/Button';
import { useLocation } from "react-router-dom";
import { Authorizer } from "../../common/Authorizer";
import {
  useHistory
} from "react-router-dom";
import CDeleteButton from "../../common/CDeleteButton";
import { FunctionField } from 'react-admin';

const RenewPolicy = (props) => {
  // console.log(props, "===PROPS===");
  let history = useHistory();
  return (
    <Button variant="contained" color="primary" onClick={() => {
      history.push(`/orders/create?oid=${props.record.id}`);
    }}>
      Renew
    </Button>
  )
}
const Filters = props => (
  <Filter {...props} variant="outlined" className="filter-block">
    <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }} filterToQuery={searchText => ({ 'name~like': searchText })}
      label="Customer" source="customerId" reference="customers" fullWidth={true} allowEmpty alwaysOn>
      <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
    </ReferenceInput>
    {/* <ReferenceInput perPage={25} sort={{ field: 'mobile', order: 'ASC' }} filterToQuery={searchText => ({ 'mobile~like': searchText })}
      label="Mobile" source="customerId" reference="customers" fullWidth={true} allowEmpty alwaysOn>
      <AutocompleteInput optionText="mobile" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
    </ReferenceInput> */}
    <TextInput variant="outlined" label="Order No" source="orderNo~like" alwaysOn />
    <TextInput variant="outlined" label="Policy No." source="policyNo~like" alwaysOn />

    <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }} filterToQuery={searchText => ({ 'name~like': searchText })}
      label="Insurer" source="insurerId" reference="insurers" fullWidth={true} allowEmpty alwaysOn>
      <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
    </ReferenceInput>

    <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }} filterToQuery={searchText => ({ 'name~like': searchText })}
      label="Policy Type" source="policyTypeId" reference="policy-types" fullWidth={true} allowEmpty alwaysOn>
      <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
    </ReferenceInput>

    <ReferenceInput perPage={25} sort={{ field: 'regnNo', order: 'ASC' }} filterToQuery={searchText => ({ 'regnNo~like': searchText })}
      label="Motor Details" source="motorId" reference="motors" fullWidth={true} allowEmpty alwaysOn>
      <AutocompleteInput optionText="regnNo" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
    </ReferenceInput>

    <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }} filterToQuery={searchText => ({ 'name~like': searchText })}
      label="RM" source="rmid" reference="employees" fullWidth={true} allowEmpty alwaysOn>
      <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
    </ReferenceInput>
    <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }} filterToQuery={searchText => ({ 'name~like': searchText })}
      label="POSP" source="pospId" reference="ref-customers" fullWidth={true} allowEmpty alwaysOn>
      <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
    </ReferenceInput>


    {/* <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }} filterToQuery={searchText => ({ 'name~like': searchText })}
      label="Hospital Name" source="hospitalId" reference="hospitals" fullWidth={true} allowEmpty alwaysOn>
      <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
    </ReferenceInput> */}
    {/* <ReferenceInput label="Hospital" source="hospitalId" reference="hospitals" sort={{ field: 'name', order: 'ASC' }} allowEmpty alwaysOn>
      <AutocompleteInput optionText="name"  shouldRenderSuggestions={(val) => { return val && val.trim().length   >= 1 }} />
    </ReferenceInput> */}
  </Filter>
);
export const OrderList = (props) => {
  const propsObj = Authorizer(props);
debugger
  //let propsObj = { ...props };
  if (propsObj.permissions) {
    let resourcename = `/${props.resource}`;
    let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
    if (myPermissions.length > 0) {
      let p = myPermissions[0];

      propsObj.hasList = (p.View == 1) ? true : false;
      propsObj.hasShow = (p.View == 1) ? true : false;
      propsObj.hasEdit = (p.Edit == 1) ? true : false;
      propsObj.hasDelete = (p.Delete == 1) ? true : false;
      propsObj.hasCreate = (p.Create == 1) ? true : false;
      propsObj.hasExport = (p.Export == 1) ? true : false;
      propsObj.nlfTCORcrd = (p.nlfTCORcrd == 1) ? true : false;
      propsObj.nlfRMORcrd = (p.nlfRMORcrd == 1) ? true : false;
      
    }
  }
  let filter: any;

  let EmployeeId: any;
  EmployeeId = localStorage.getItem("EmployeeId");
//   if (propsObj.nlfTCORcrd) {
//   
//     if (EmployeeId) {
//       EmployeeId = parseInt(EmployeeId);
//       // propsObj.filter={tcid: EmployeeId}
//       filter = {
//         where: {
//           or: [
//             { tcid: parseInt(EmployeeId) },
//             // {price: {lt: 50}}
//           ]
//         }
//       }
//     }
// if (propsObj.nlfRMORcrd) {
//     EmployeeId = localStorage.getItem("EmployeeId");
//     if (EmployeeId) {
//       EmployeeId = parseInt(EmployeeId);
//       // propsObj.filter={tcid: EmployeeId}
//       filter = {
//         where: {
//           or: [
//             { rmid: parseInt(EmployeeId) },
//             // {price: {lt: 50}}
//           ]
//         }
//       }
//     }


//   }


debugger
let rmid=0;
let tcid=0;
if (EmployeeId) {
  
  EmployeeId = parseInt(EmployeeId);  
  const where: any = {}; 
  if (propsObj.nlfTCORcrd) {
    tcid = EmployeeId;
  }

  if (propsObj.nlfRMORcrd) {
    rmid= EmployeeId;
  }

  
}

  return (
    <List {...propsObj} exporter={propsObj.hasExport} bulkActionButtons={false} className="grid-list" classes={{ actions: "my-action", main: "main", content: "content", }}
      title="Order List"  
      //filter={propsObj?.filter?.where ? propsObj?.filter?.where : null}
      
      //filter={rmid>0 ? { rmid: rmid }  : null}
      filter={rmid && rmid>0?{ rmid: rmid }:null}



      filters={<Filters />} sort={{ field: 'id', order: 'DESC' }} >
      <Datagrid rowClick={false}>
        {propsObj.hasEdit && <EditButton />}
        {!propsObj.hasEdit && <EditButton label="View" />}
        {
          propsObj.nlfRenew &&
          <RenewPolicy label="Renewal" />}
        {propsObj.hasDelete && <CDeleteButton {...props} />}
        <ReferenceField label="Booking Branch" source="configId" reference="configs" link={false}>
          <TextField source="mconame" />
        </ReferenceField>
        <TextField source="orderNo" label="Order no" />
        <ReferenceField label="Previous Order" source="linkOrderId" reference="orders" link={false}>
          <TextField source="orderNo" />
        </ReferenceField>
        <DateField source="orderDate" label="order Date" locales="fr-FR" />
        <TextField source="policyNo" label="Policy No" />
        <ReferenceField label="Biz Type" source="bizTypeId" reference="biz-types" link={false}>
          <TextField source="name" />
        </ReferenceField>

        <ReferenceField label="Customer" source="customerId" reference="customers" link={false}>
          <TextField source="name" />
        </ReferenceField>

        {/* <ReferenceField label="Mobile" source="customerId" reference="customers" link={false}>
          <TextField source="mobile" />
        </ReferenceField>


        <ReferenceField label="Customer Group" source="custGroupId" reference="cust-groups" link={false}>
          <TextField source="name" />
        </ReferenceField> */}

        <ReferenceField label="Insurer" source="insurerId" reference="insurers" link={false}>
          <TextField source="name" />
        </ReferenceField>

        <ReferenceField label="Insurer Branch" source="insurerBrancheId" reference="insurer-branches" link={false}>
          <TextField source="name" />
        </ReferenceField>

        <ReferenceField label="Policy Department" source="policyDepartmentId" reference="policy-departments" link={false}>
          <TextField source="name" />
        </ReferenceField>

        <ReferenceField label="Policy Type" source="policyTypeId" reference="policy-types" link={false}>
          <TextField source="name" />
        </ReferenceField>

        <DateField source="policyStartDate" label="Policy Start Date" locales="fr-FR" />
        <DateField source="policyEndDate" label="Policy End Date" locales="fr-FR" />

        <ReferenceField source="createdBy" reference="users" label="Created By" link={false}>
          <TextField source="userName" />
        </ReferenceField>

        <ReferenceField label="RM Name" source="rmid" reference="employees" link={false}>
          <TextField source="name" />
        </ReferenceField>

        <ReferenceField label="POSP Name" source="pospId" reference="ref-customers" link={false}>
          <TextField source="name" />
        </ReferenceField>

        <ReferenceField label="Ref Name" source="refid" reference="ref-customers" link={false}>
          <TextField source="name" />
        </ReferenceField>

        <TextField source="camaignName" label="Camaign Name" />

        <TextField source="odPremAmt" label="OD Premium" />

        <TextField source="tpPremiumAmt" label="TP Premium" />

        <FunctionField
          label="Net Premium"
          render={record =>
            (record?.odPremAmt || 0) + (record?.tpPremiumAmt || 0)
          }
/>

       {/* <BooleanField label="Is Cover note" source="isCoverNote" />

        <TextField source="coverNote" label="Cover Note" />

 */}
        <DateField source="createdDate" label="Created Date" locales="fr-FR" />
        <ReferenceField source="modifyBy" reference="users" label="Updated By" link={false}>
          <TextField source="userName" />
        </ReferenceField>
        <DateField source="modifyDate" label="Updated Date" locales="fr-FR" />

      </Datagrid>
    </List>
  );
};
